import styled from "styled-components";

export const ShaTitleStyledWrapper = styled.header`
  margin: auto;
  padding: 18px;
  width: 80%;

  .sha-title {
    border-bottom: 2px solid #d9d9d9;
    color: #2c2738;
    font-size: 56px;
    font-weight: bold;
    margin: 0;
    margin-bottom: 18px;
    padding-bottom: 8px;
    text-align: center;
  }
`;
